export default __webpack_public_path__ + "static/media/3b.35355a4e.png";